<template>
  <div>
    <Navbar v-if="$route.name === 'learninghubbourses'" />
    <!-- <Breadcrumb v-if="$route.name === 'learninghubbourses'" /> -->
    <div class="px-3" v-show="course_id === 0">
      <div class="row mt-3 mb-3">
        <div class="col-8">
          <div class="d-flex flex-nowrap" style="gap: 0.5rem;">
            <button
              @click.prevent="newCourse"
              class="btn btn-primary gdq_faded gdq-font-size-80"
              style="width: 8.33%;"
            >
              <span class="icon-plus mr-1"></span>Add
            </button>
            <select
              v-model="filterstatus"
              class="form-select gdq-font-size-80"
              style="width: 8.33%;"
            >
              <option value="0">Status</option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
            </select>
          </div>
        </div>
        <div class="col-2">
          <div class="input-group input-group-sm">
            <input
              v-model="searchId"
              placeholder="Id"
              type="text"
              class="form-control gdq-font-size-80"
              autocomplete="off"
            />
            <button class="btn btn-outline-secondary" type="button" @click="searchId = ''">X</button>
          </div>
        </div>
        <div class="col-2">
          <div class="input-group input-group-sm">
            <input
              v-model="search"
              placeholder="Name/course..."
              type="text"
              class="form-control gdq-font-size-80"
              autocomplete="off"
            />
            <button class="btn btn-outline-secondary" type="button" @click="search = ''">X</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mb-3 text-start">Number of courses in the list: {{ rows }}</div>
      </div>

      <table class="table table-hover coursesTable">
        <thead>
          <tr>
            <th style="cursor:pointer;" @click="handleSort('id')">
              ID <span v-if="orderby === 'id'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th style="cursor:pointer;" @click="handleSort('name')">
              Name <span v-if="orderby === 'name'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th style="cursor:pointer;" @click="handleSort('track')">
              Track <span v-if="orderby === 'track'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th style="cursor:pointer;" @click="handleSort('course_label')">
              Course <span v-if="orderby === 'course_label'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th style="cursor:pointer;" @click="handleSort('language_id')">
              Language <span v-if="orderby === 'language_id'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th style="cursor:pointer;" @click="handleSort('active')">
              Active <span v-if="orderby === 'active'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th style="cursor:pointer;" @click="handleSort('enrolment_count')">
              Enrolments <span v-if="orderby === 'enrolment_count'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th style="cursor:pointer;" @click="handleSort('updated_at')">
              Updated <span v-if="orderby === 'updated_at'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th>⚡</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in pagedCourses"
            :key="item.id"
            style="cursor: pointer;"
            @click="editCourse(item)"
          >
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>
              <span class="badge bg-light text-dark">{{ cap(item.track) }}</span>
            </td>
            <td>{{ item.course_label || '-' }}</td>
            <td>{{ langName(item.language_id) }}</td>
            <td>{{ item.active ? 'Yes' : 'No' }}</td>
            <td>{{ item.enrolment_count }}</td>
            <td>{{ fmtDate(item.updated_at) }}</td>
            <td>
              <span
                style="cursor: pointer;"
                @click.prevent.stop="delCourse(item)"
              >
                <fa-icon name="trash-alt" />
              </span>
            </td>
          </tr>
          <tr v-if="!loading && rows === 0">
            <td colspan="9" class="text-center text-muted py-4">No courses found</td>
          </tr>
        </tbody>
      </table>
      <Pagination
        :current-page="currentPage"
        :per-page="perPage"
        :total-rows="rows"
        aria-label="Courses pagination"
        @page-changed="currentPage = $event"
      />
    </div>
    <div v-if="course_id != 0">
      <LearningHubCourse
        :key="course_id"
        :course-id="course_id"
        @back="course_id = 0"
        @saved="course_id = $event"
      />
    </div>
  </div>
</template>

<script>
import Navbar from './Navbar.vue'
// import Breadcrumb from './Breadcrumb.vue'
import Pagination from './Pagination.vue'
import LearningHubCourse from './LearningHubCourse.vue'

export default {
  name: 'LearningHubCourses',
  components: { Navbar, Pagination, LearningHubCourse },
  data () {
    return {
      course_id: 0,
      courses: [],
      languages: [],
      loading: false,
      search: '',
      searchId: '',
      filterstatus: '0',
      orderby: 'id',
      orderdesc: false,
      currentPage: 1,
      perPage: 10
    }
  },
  computed: {
    filtered () {
      let list = this.courses
      if (this.searchId !== '' && this.searchId !== null) {
        list = list.filter(p => String(p.id) === String(this.searchId))
      }
      if (this.filterstatus !== '0') {
        list = list.filter(p => this.filterstatus === '1' ? p.active : !p.active)
      }
      if (this.search) {
        const q = this.search.toLowerCase()
        list = list.filter(p =>
          (p.name || '').toLowerCase().includes(q) ||
          (p.course_label || '').toLowerCase().includes(q)
        )
      }
      const key = this.orderby
      const dir = this.orderdesc ? -1 : 1
      return [...list].sort((a, b) => {
        const va = a[key] ?? ''
        const vb = b[key] ?? ''
        if (typeof va === 'number' && typeof vb === 'number') return (va - vb) * dir
        return String(va).localeCompare(String(vb)) * dir
      })
    },
    rows () {
      return this.filtered.length
    },
    pagedCourses () {
      const start = (this.currentPage - 1) * this.perPage
      return this.filtered.slice(start, start + this.perPage)
    }
  },
  created () {
    this.languages_get()
    this.courses_get()
  },
  methods: {
    async languages_get () {
      try {
        const res = await this.$store.dispatch('languages_fetch')
        this.languages = res.data.result
      } catch (e) { this.languages = [] }
    },
    async courses_get () {
      this.loading = true
      try {
        const res = await this.$store.dispatch('learninghub_courses_fetch')
        this.courses = res.data.result
      } catch (e) {
        this.courses = []
      }
      this.loading = false
    },
    handleSort (key) {
      if (this.orderby === key) {
        this.orderdesc = !this.orderdesc
      } else {
        this.orderby = key
        this.orderdesc = false
      }
    },
    langName (id) {
      if (!id) return '-'
      const l = this.languages.find(x => x.id === id)
      return l ? l.language_name : '-'
    },

    cap (s) {
      return s ? s.charAt(0).toUpperCase() + s.slice(1) : s
    },
    fmtDate (s) {
      if (!s) return '-'
      return String(s).substring(0, 10)
    },
    editCourse (p) {
      this.course_id = p.id
    },
    newCourse () {
      this.course_id = -1
    },
    delCourse (p) {
      if (!confirm('Delete course "' + p.name + '"? All sessions, steps, materials, trainers, terms, Sue KB entries, enrolments and progress will be deleted.')) return
      this.$store.dispatch('learninghub_course_delete', { id: p.id }).then(() => {
        this.courses_get()
      }).catch(e => {
        const msg = e.response && e.response.data && typeof e.response.data.result === 'string'
          ? e.response.data.result
          : (e.message || 'Delete failed')
        alert(msg)
      })
    }
  }
}
</script>

<style>
.coursesTable {
  font-size: 0.9rem !important;
}
</style>
